import { render, staticRenderFns } from "./ReminderPlanChangeActivationType.vue?vue&type=template&id=a0f83222&"
import script from "./ReminderPlanChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports